import styled from 'styled-components';

export const LoadingCenteredStyled = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
